/**
 * 決定論的な擬似乱数（mulberry32）。
 *
 * シミュレーションは Math.random を一切使わない。同じシードから常に同じ海が
 * 生成されることが、ランキング検証・ゴースト・リプレイ動画のすべての前提になる。
 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** 乱数から範囲付きの値を取り出すヘルパ群。使う順番が変わると海が変わる点に注意。 */
export class Rand {
  private readonly next: () => number;

  constructor(seed: number) {
    this.next = mulberry32(seed);
  }

  unit(): number {
    return this.next();
  }

  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  int(minInclusive: number, maxInclusive: number): number {
    return minInclusive + Math.floor(this.next() * (maxInclusive - minInclusive + 1));
  }

  pick<T>(items: readonly T[]): T {
    return items[Math.min(items.length - 1, Math.floor(this.next() * items.length))];
  }
}

/** 日替わりチャレンジ用。UTC の日付から全プレイヤー共通のシードを作る。 */
export function dailySeed(date: Date): number {
  const y = date.getUTCFullYear();
  const m = date.getUTCMonth() + 1;
  const d = date.getUTCDate();
  return (y * 10000 + m * 100 + d) >>> 0;
}
